export default __webpack_public_path__ + "static/media/iconPrint.21aced4b.svg";